export default __webpack_public_path__ + "static/media/wallpaper_1.38a75403.jpg";